import React, { useState } from 'react';
import axios from 'axios';

const TestUserUpdate = () => {
  const [userId, setUserId] = useState('4');
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Test data for user update
      const userData = {
        username: 'user_4',
        name: 'Test User 4 Updated',
        email: 'test@example.com',
        role: 'seller',
        subscriptionTier: 'Starter',
        subscriptionStatus: 'active'
      };
      
      // Make the API call with debug logging
      console.log('Sending update request for user ID:', userId);
      console.log('Update data:', userData);
      
      const result = await axios.put(`/api/admin/users/${userId}`, userData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('Update response:', result.data);
      setResponse(result.data);
      
      // Fetch the user after update to verify changes
      const userResponse = await axios.get(`/api/admin/users/${userId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('User after update:', userResponse.data);
      
    } catch (err: any) {
      console.error('Error updating user:', err);
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Test User Update</h1>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">User ID:</label>
        <input 
          type="text" 
          value={userId} 
          onChange={(e) => setUserId(e.target.value)}
          className="border rounded px-3 py-2 w-full max-w-xs"
        />
      </div>
      
      <button
        onClick={handleUpdate}
        disabled={loading}
        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
      >
        {loading ? 'Updating...' : 'Update User'}
      </button>
      
      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
      
      {response && (
        <div className="mt-4">
          <h2 className="text-xl font-semibold mb-2">Response:</h2>
          <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-60">
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestUserUpdate;
